export const ratesErrorCodes = {
  minimumOccupancy: 'minimum_occupancy',
  maximumOccupancy: 'maximum_occupancy',
  maximumLengthOfStay: 'maximum_length_of_stay',
  quantityIsZero: 'quantity_is_zero',
  priceIsZero: 'price_is_zero',
};
